const extraPaths = {
	pod_form: '/extra/pod-form',
}

export default extraPaths
